/**
 * @typedef {Object} SerializerType
 *
 * @property {(raw?: *) => string|null} serialize
 * @property {(serialized: string|Array|number) => *} deserialize
 */

/** @type {SerializerType} */
export const string = {
    serialize: raw => raw || null,
    deserialize: serialized => serialized || null,
}

/** @type {SerializerType} */
export const integer = {
    serialize: raw => '' + raw || null,
    deserialize: serialized => {
        const number = parseInt('' + serialized)
        return (!isNaN(number)) ? number : null
    },
}

/** @type {SerializerType} */
export const float = {
    serialize: raw => '' + raw || null,
    deserialize: serialized => {
        const number = parseFloat('' + serialized)
        return (!isNaN(number)) ? number : null
    },
}

/** @type {SerializerType} */
export const boolean = {
    serialize: raw => {
        switch (raw) {
            case true: return '1'
            case false: return '0'
            default: return null
        }
    },
    deserialize: serialized => {
        switch (serialized) {
            case '1': return true
            case '0': return false
            default: return null
        }
    },
}

/**
 * @param {SerializerType} type Type of the single items
 */
export const listOf = type => ({
    serialize: raw => {
        const list = []
        raw.forEach(item => {
            const serialized = type.serialize(item)
            if (serialized) list.push(serialized)
        })
        return list.length ? list.join(',') : null
    },
    deserialize: serialized => {
        const list = []
        const valuesArray = (Array.isArray(serialized)) ? serialized : serialized.split(',')
        valuesArray.forEach(value => {
            const converted = type.deserialize(value)
            if (converted !== null) {
                list.push(converted)
            }
        })
        return list
    },
})

/**
 * @param {SerializerType} type Type of the single items
 * @param {number} min Minimal allowed value
 * @param {number} max Maximal allowed value
 */
export const rangeListOf = (type, min, max) => ({
    serialize: listOf(type).serialize,
    deserialize: serialized => {
        const value = listOf(type).deserialize(serialized)
        if (!value) return null
        let [low, high] = value
        // Make sure min is lower than max and both are in the range, so that it always results
        // in a valid state
        if (!low || low < min || low > high || low > max) {
            low = min
        }
        if (!high || high < min || high > max) {
            high = max
        }
        return [low, high]
    },
})
